import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const TEAL = "#1D9E75";
const NAVY = "#1a2e4a";
const LIGHT_TEAL = "#E8F6F1";
const LIGHT_NAVY = "#E8EDF3";
const GRAY = "#64748B";
const WHITE = "#FFFFFF";

const kpis = [
  { label: "Inversión Fase I", value: "$365K", sub: "Copacking", bg: LIGHT_NAVY, color: NAVY },
  { label: "Inversión Fase II", value: "$500K", sub: "Maquinaria", bg: LIGHT_NAVY, color: NAVY },
  { label: "Ingresos Año 1", value: "$6.1M", sub: "USD", bg: LIGHT_TEAL, color: TEAL },
  { label: "Ingresos Año 2", value: "$13.4M", sub: "USD", bg: LIGHT_TEAL, color: TEAL },
  { label: "Rentabilidad Año 1", value: "$312K", sub: "USD", bg: LIGHT_TEAL, color: TEAL },
  { label: "Rentabilidad Año 2", value: "$449K", sub: "USD", bg: LIGHT_TEAL, color: TEAL },
  { label: "Recuperación", value: "12", sub: "meses", bg: LIGHT_NAVY, color: NAVY },
];

const ventasAnio1 = [
  { mes: "Ene", fcl: 1, usd: 143 },
  { mes: "Feb", fcl: 1, usd: 143 },
  { mes: "Mar", fcl: 2, usd: 286 },
  { mes: "Abr", fcl: 3, usd: 419 },
  { mes: "May", fcl: 3, usd: 419 },
  { mes: "Jun", fcl: 4, usd: 551 },
  { mes: "Jul", fcl: 5, usd: 694 },
  { mes: "Ago", fcl: 5, usd: 694 },
  { mes: "Sep", fcl: 5, usd: 694 },
  { mes: "Oct", fcl: 5, usd: 694 },
  { mes: "Nov", fcl: 5, usd: 694 },
  { mes: "Dic", fcl: 5, usd: 694 },
];

const ventasAnio2 = [
  { mes: "Ene", fcl: 5, usd: 694 },
  { mes: "Feb", fcl: 5, usd: 694 },
  { mes: "Mar", fcl: 5, usd: 694 },
  { mes: "Abr", fcl: 5, usd: 694 },
  { mes: "May", fcl: 5, usd: 694 },
  { mes: "Jun", fcl: 5, usd: 694 },
  { mes: "Jul", fcl: 5, usd: 694 },
  { mes: "Ago", fcl: 5, usd: 694 },
  { mes: "Sep", fcl: 5, usd: 694 },
  { mes: "Oct", fcl: 5, usd: 694 },
  { mes: "Nov", fcl: 5, usd: 694 },
  { mes: "Dic", fcl: 5, usd: 694 },
];

const comparativo = [
  { name: "Volumen (M lb)", anio1: 2.0, anio2: 2.7 },
  { name: "Ingresos (M USD)", anio1: 6.1, anio2: 13.4 },
  { name: "Rentabilidad (K USD)", anio1: 312, anio2: 449 },
];

const productos = [
  { producto: "Shellon", lb: "50,000 lb", fclA1: "16 FCL", fclA2: "24 FCL", mesA1: "Mes 10" },
  { producto: "Valor Agregado", lb: "44,000 lb", fclA1: "28 FCL", fclA2: "36 FCL", mesA1: "Mes 12" },
];

const inversion = [
  { fase: "Fase I — Copacking", total: "$365,000", items: [] },
  { fase: "Fase II — Maquinaria", total: "$500,000", items: [
    { name: "Clasificadora", amount: "$100,000" },
    { name: "Peladora e Hidratadores", amount: "$300,000" },
    { name: "Obra Civil", amount: "$100,000" },
  ]},
];

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload) return null;
  return (
    <div style={{ background: NAVY, padding: "10px 14px", borderRadius: 8, border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}>
      <div style={{ color: "#94A3B8", fontSize: 11, marginBottom: 4 }}>{label}</div>
      {payload.map((p, i) => (
        <div key={i} style={{ color: p.color, fontSize: 13, fontWeight: 600 }}>
          {p.name}: {typeof p.value === "number" && p.value > 100 ? `$${p.value}K` : p.value}
        </div>
      ))}
    </div>
  );
};

export default function DashboardCamaron() {
  const section = { marginBottom: 32 };
  const sectionTitle = { fontSize: 15, fontWeight: 700, color: NAVY, marginBottom: 16, letterSpacing: "0.5px", textTransform: "uppercase", borderBottom: `2px solid ${TEAL}`, paddingBottom: 8, display: "inline-block" };
  const cardStyle = { background: WHITE, borderRadius: 10, padding: "18px 20px", boxShadow: "0 1px 4px rgba(0,0,0,0.04)", border: "1px solid #E8ECF0" };

  return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif", background: "#F7F9FB", minHeight: "100vh", padding: 0 }}>

      {/* Header */}
      <div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, #2a4a6a 100%)`, padding: "28px 36px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 12, color: TEAL, fontWeight: 600, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Dashboard Ejecutivo</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: WHITE, letterSpacing: "-0.5px" }}>Línea de Camarón</div>
          <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 4 }}>Proyección financiera y operativa — Año 1 y Año 2</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 36, fontWeight: 800, color: TEAL }}>$865K</div>
          <div style={{ fontSize: 11, color: "#94A3B8" }}>Inversión total</div>
        </div>
      </div>

      <div style={{ padding: "28px 36px", maxWidth: 1300, margin: "0 auto" }}>

        {/* KPIs */}
        <div style={section}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 12 }}>
            {kpis.map((k, i) => (
              <div key={i} style={{ background: k.bg, borderRadius: 10, padding: "16px 14px", textAlign: "center", border: `1px solid ${k.color}15` }}>
                <div style={{ fontSize: 11, color: GRAY, fontWeight: 600, marginBottom: 8, lineHeight: 1.3 }}>{k.label}</div>
                <div style={{ fontSize: 26, fontWeight: 800, color: k.color, lineHeight: 1 }}>{k.value}</div>
                <div style={{ fontSize: 10, color: GRAY, marginTop: 4 }}>{k.sub}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Ventas Año 1 + Año 2 */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, ...section }}>
          <div style={cardStyle}>
            <div style={sectionTitle}>Ventas mensuales — Año 1</div>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={ventasAnio1} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8ECF0" />
                <XAxis dataKey="mes" tick={{ fontSize: 11, fill: GRAY }} />
                <YAxis tick={{ fontSize: 11, fill: GRAY }} />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey="usd" name="Ventas (K USD)" fill={TEAL} radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: GRAY, marginTop: 8, padding: "0 8px" }}>
              <span>Ramp-up: 1 → 5 FCL</span>
              <span style={{ fontWeight: 700, color: TEAL }}>Total: $6.1M</span>
            </div>
          </div>

          <div style={cardStyle}>
            <div style={sectionTitle}>Ventas mensuales — Año 2</div>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={ventasAnio2} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8ECF0" />
                <XAxis dataKey="mes" tick={{ fontSize: 11, fill: GRAY }} />
                <YAxis tick={{ fontSize: 11, fill: GRAY }} />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey="usd" name="Ventas (K USD)" fill={NAVY} radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: GRAY, marginTop: 8, padding: "0 8px" }}>
              <span>Operación estable: 5 FCL/mes</span>
              <span style={{ fontWeight: 700, color: NAVY }}>Total: $13.4M</span>
            </div>
          </div>
        </div>

        {/* Comparativo + Productos */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, ...section }}>
          <div style={cardStyle}>
            <div style={sectionTitle}>Comparativo Año 1 vs Año 2</div>
            <ResponsiveContainer width="100%" height={240}>
              <BarChart data={comparativo} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8ECF0" />
                <XAxis dataKey="name" tick={{ fontSize: 10, fill: GRAY }} />
                <YAxis tick={{ fontSize: 11, fill: GRAY }} />
                <Tooltip content={<CustomTooltip />} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Bar dataKey="anio1" name="Año 1" fill={TEAL} radius={[4, 4, 0, 0]} />
                <Bar dataKey="anio2" name="Año 2" fill={NAVY} radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div style={cardStyle}>
            <div style={sectionTitle}>Volumen por producto</div>
            <div style={{ marginTop: 8 }}>
              {productos.map((p, i) => (
                <div key={i} style={{ background: i === 0 ? LIGHT_TEAL : LIGHT_NAVY, borderRadius: 10, padding: "16px 20px", marginBottom: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: i === 0 ? TEAL : NAVY }}>{p.producto}</div>
                    <div style={{ fontWeight: 700, fontSize: 14, color: GRAY }}>{p.lb}</div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                    <div>
                      <div style={{ fontSize: 10, color: GRAY, marginBottom: 2 }}>Inicio</div>
                      <div style={{ fontWeight: 700, fontSize: 13, color: i === 0 ? TEAL : NAVY }}>{p.mesA1}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: 10, color: GRAY, marginBottom: 2 }}>FCL Año 1</div>
                      <div style={{ fontWeight: 700, fontSize: 13, color: i === 0 ? TEAL : NAVY }}>{p.fclA1}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: 10, color: GRAY, marginBottom: 2 }}>FCL Año 2</div>
                      <div style={{ fontWeight: 700, fontSize: 13, color: i === 0 ? TEAL : NAVY }}>{p.fclA2}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Inversión */}
        <div style={section}>
          <div style={cardStyle}>
            <div style={sectionTitle}>Estructura de inversión</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginTop: 8 }}>
              {inversion.map((fase, i) => (
                <div key={i} style={{ background: i === 0 ? LIGHT_TEAL : LIGHT_NAVY, borderRadius: 10, padding: "20px 24px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: i === 0 ? TEAL : NAVY }}>{fase.fase}</div>
                    <div style={{ fontWeight: 800, fontSize: 20, color: i === 0 ? TEAL : NAVY }}>{fase.total}</div>
                  </div>
                  {fase.items.length > 0 && (
                    <div style={{ borderTop: `1px solid ${i === 0 ? TEAL : NAVY}20`, paddingTop: 12 }}>
                      {fase.items.map((item, j) => (
                        <div key={j} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
                          <span style={{ color: GRAY }}>{item.name}</span>
                          <span style={{ fontWeight: 700, color: i === 0 ? TEAL : NAVY }}>{item.amount}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  {fase.items.length === 0 && (
                    <div style={{ fontSize: 12, color: GRAY }}>Infraestructura inicial para operaciones de copacking con terceros</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", padding: "16px 0", fontSize: 11, color: "#94A3B8" }}>
          Dashboard Ejecutivo — Línea de Camarón · Proyección a 2 años · Confidencial
        </div>
      </div>
    </div>
  );
}
